/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React from 'react';
import { Input, Label } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import get from 'lodash/get';

@inject('storeAppearanceStore', 'appStore')
@observer
class DomainInput extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.abortRequest = this.abortRequest.bind(this);
        this.state = {
            valid: 'initial',
        };
        this.request = false;
        this.abortFunc = false;
    }

    abortRequest(cb) {
        this.abortFunc = cb;
    }

    async onChange(e, d) {
        if (this.props.onChange) this.props.onChange(e, d);

        const domain = 'https://' + d.value + '.nunchee.tv';

        if (domain === this.props.defaultValue) {
            if (this.abortFunc) {
                this.abortFunc();
                this.abortFunc = false;
            }
            this.setState({ valid: 'initial' });
            return;
        }

        if (this.abortFunc) {
            this.abortFunc();
            this.abortFunc = false;
        }
        const res = await this.props.storeAppearanceStore.checkDomain(domain, this.abortRequest);
        if (res === true) {
            this.setState({ valid: true }, this.onValidChange);
        } else if (res && res.error) {
            this.setState({ valid: false }, this.onValidChange);
        }
    }

    onValidChange = () => {
        if (this.props.onValidChange) this.props.onValidChange(this.state.valid);
    };

    render() {
        const {
            labelText = '.nunchee.tv',
            labelPosition = 'right',
            storeAppearanceStore,
            defaultValue,
            site,
            label,
            appStore,
            isCustomDomain = false,
            ...rest
        } = this.props;

        const { valid } = this.state;
        const sendToSQS = get(appStore.versions, `web.store.sendToSQS`, false);
        const status = get(appStore.versions, `web.store.status`, -1);
        let goMySiteAttrs = {
            style: {
                color:  sendToSQS && status === 3  ? '#00C4CD' : 'gray',
                height: '32px',
                fontFamily: 'Roboto, sans-serif'
            },
            basic:'true',
            as:  sendToSQS && status === 3 ? 'a' : null,
            target: '_blank',
            content: label,
            icon:'linkify',
        };

        const labelForInput = isCustomDomain ? 'Custom Domain' : labelText;

        if (sendToSQS && status === 3)
            Object.assign(goMySiteAttrs, {
                href: isCustomDomain ?
                    get(appStore, 'app.settings.customSite', '') :
                    get(appStore, 'app.settings.site', '')
            });

        return (
            <React.Fragment>
                <Input
                    label={{ basic: true, content: labelForInput }}
                    labelPosition={labelPosition}
                    {...rest}
                    readOnly={isCustomDomain}
                    onChange={this.onChange}
                    error={valid === false}
                    className={valid === true ? 'available' : ''}
                >
                    <input />
                    <Label
                        basic="true"
                        content={labelForInput}
                    />
                    <Label
                        {...goMySiteAttrs}
                    />
                </Input>
            </React.Fragment>
        );
    }
}

export default DomainInput;
